import { useQuery } from '@tanstack/react-query';

import type { components } from '@luxuryescapes/contract-svc-promo/generated';

import { type ChannelMarkupV2Internal, getChannelMarkupListV2 } from '~/services/PromoService';

import { channelMarkupV2QueryKeys } from './useGetChannelMarkupV2ById';

type Params = {
  brand: components['schemas']['Promo Brands'];
  enabled?: boolean;
};

type ChannelMarkupV2ListResponse = {
  channelMarkupList?: Array<ChannelMarkupV2Internal>;
};

export function useGetActiveChannelMarkupV2List({ brand, enabled = true }: Params) {
  return useQuery<ChannelMarkupV2ListResponse>({
    queryKey: [...channelMarkupV2QueryKeys.all, 'list', brand, 'active'] as const,
    queryFn: async () => {
      const response = await getChannelMarkupListV2({
        page: 0,
        pageSize: 1000,
        brand,
        status: 'active',
      });

      return response.result;
    },
    enabled: enabled && Boolean(brand),
  });
}
